import { render, staticRenderFns } from "./OverenoConsent.vue?vue&type=template&id=9dfe80ce&"
import script from "./OverenoConsent.vue?vue&type=script&lang=js&"
export * from "./OverenoConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports